/**
 * Input Schema of Endereco
 * @author Simpli CLI generator
 */
import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {slice} from 'lodash'

export class InputEnderecoMotoristaSchema extends Schema {
  readonly name = 'InputEndereco'

  get secondaryFields() {
    return slice(this.allFields, 1)
  }

  readonly fieldSet: FieldSet<Endereco> = {
    cep: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'zipcode',
        label: this.translateFrom(schema.fieldName),
        validation: 'cep',
      },
      on: {
        input: () => {
          if (schema.model.cep?.length === 8) {
            $.await.run(`populateEnderecoFromCEP`, () =>
              schema.model.populateFromCEP()
            )
          }
        },
      },
    }),
    logradouro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        required: false,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 45,
        label: this.translateFrom(schema.fieldName),
      },
    }),

    bairro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    cidade: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        required: false,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    uf: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 2,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    pais: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        inputClass: 'uppercase',
      },
    }),
    complemento: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        inputClass: 'uppercase',
      },
    }),
  }
}
